module.exports = __webpack_public_path__ + "static/AgileTeamPlaceholder-3019c510c6a428e2e826bef716037d37.png";